import clsx from "clsx";
import { Link } from "react-router-dom";
import { socialItems } from "screens/Landing/constants";
import { shadowAndBorderClass } from "screens/Dashboard/utils/classes";

type SocialIconsProps = {
  variant?: "light" | "dark";
};

const SocialIcons = ({ variant = "light" }: SocialIconsProps) => {
  const isDark = variant === "dark";

  return (
    <div className="flex gap-[8px] max-lg:gap-[8px]">
      {socialItems.map(({ id, icon, linkUrl }) => (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to={linkUrl}
          key={id}
          className={clsx(
            "flex max-lg:size-[50px] p-[2px] overflow-hidden shrink-0 size-[51px] items-center justify-center rounded-full transition-colors duration-300",
            isDark
              ? clsx(
                  "bg-[#252525] border-[1px] border-white/[0.08] hover:bg-[#333333]",
                )
              : "shadow-custom social-icon bg-[#E9EBF3] hover:bg-blue-200",
          )}
        >
          <img
            src={icon}
            alt="social icon"
            className={clsx(
              "size-[24px] max-lg:size-[24px]",
              // Social icons are black SVG assets; invert them for dark surfaces.
              isDark && "filter invert",
            )}
          />
        </Link>
      ))}
    </div>
  );
};

export default SocialIcons;
